import { select } from '@js/util/select.js'

function applyFitToWidth(element) {
  const resizeObserver = new ResizeObserver(() => {
    fitTextToWidth(element)
  })

  const intersectionObserver = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          // Initial fit
          fitTextToWidth(element)
          resizeObserver.observe(element)
        } else {
          resizeObserver.unobserve(element)
        }
      })
    },
    {
      root: null,
      rootMargin: '100% 100% 100% 100%',
    },
  )

  intersectionObserver.observe(element)

  return () => {
    resizeObserver.disconnect()
  }
}

function fitTextToWidth(element) {
  const container = element
  const containerWidth = container.offsetWidth

  if (containerWidth === 0) return

  let minSize = 1
  let maxSize = 10_000
  let fontSize = 16

  // Binary search for optimal font size
  while (minSize <= maxSize) {
    fontSize = Math.floor((minSize + maxSize) / 2)
    container.style.fontSize = fontSize + 'px'

    const scrollWidth = container.scrollWidth

    if (scrollWidth <= containerWidth) {
      // Text fits, try larger
      minSize = fontSize + 1
    } else {
      // Text overflows, try smaller
      maxSize = fontSize - 1
    }
  }

  // Set final size (maxSize is the largest size that fits)
  container.style.fontSize = maxSize + 'px'
}

if (!CSS.supports('animation-range: entry-crossing')) {
  select('.fit-to-width', element => {
    const disconnect = applyFitToWidth(element)

    return () => {
      disconnect()
    }
  })
}
